var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"filterable":"","clearable":"","placeholder":"请选择","size":"small"},on:{"change":_vm.handleChange},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item,attrs:{"label":item,"value":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }